// Code generated by '@graphql-codegen'; DO NOT EDIT.

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "SummaryUnion": [
      "InsightsMarketingSummaryObj",
      "InsightsProductSummaryObj"
    ]
  }
};
      export default result;
    